import {DateFilter} from '@components/statistics/stats-reports/filter-components/date-filter'
import {ActionFilter} from '@components/statistics/stats-timeline/filter/filter-action'
import {observer} from 'mobx-react-lite'
import React, {useEffect, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {TimelineFilter} from 'yougile-model'
import {useTaskEventLogStore} from '../task-event-log-store'
import FilterSVG from './filter.svg'

const TwWrapper = tw.div`
  flex
  mt-20
`

const TwSVGWrapper = tw.div<{selected: boolean}>`
  flex
  mr-4
  ${p => (p.selected ? 'text-accent-old' : 'text-obscure-old')}
`

interface Props {
  initialFilter: TimelineFilter
}

export const Filter = observer((props: Props) => {
  const [, store] = useTaskEventLogStore()
  const {initialFilter} = props
  useEffect(() => changeFilter(initialFilter), [initialFilter])
  const [currentFilter, changeFilter] = useState(initialFilter)

  const updateFilter =
    <T extends keyof TimelineFilter>(filterName: T) =>
    (filter: TimelineFilter[T]) => {
      changeFilter({
        ...currentFilter,
        [filterName]: filter
      })
    }

  const onOpenChange = (isOpen: boolean) => {
    if (currentFilter !== initialFilter && !isOpen) {
      store.setActiveFilterForce({
        ...currentFilter
      })
    }
  }

  return (
    <TwWrapper>
      <TwSVGWrapper selected={!!store.activeFilter.length}>
        <FilterSVG />
      </TwSVGWrapper>
      <div
        className={`${
          currentFilter.createdAt?.custom ? 'flex flex-col' : 'flex'
        }`}
      >
        <div className="mb-16">
          <DateFilter
            filter={currentFilter.createdAt}
            update={updateFilter('createdAt')}
            isAny
            placeholder={Lang.msg.statsTimeline.anyDate}
            dontOpen
            showRemoveButton={false}
            onOpenChange={isOpen => {
              onOpenChange(isOpen)
            }}
            classNameWidth={'w-136'}
            moveDates={false}
          />
        </div>
        <div
          className={`${currentFilter.createdAt?.custom ? 'ml-0' : 'ml-16'}`}
        >
          <ActionFilter
            filter={currentFilter.action}
            update={updateFilter('action')}
            showRemoveButton={false}
            onOpenChange={isOpen => {
              onOpenChange(isOpen)
            }}
            placeholder={Lang.msg.statsTimeline.allActions}
            classNameWidth={'w-136'}
            withoutProjectAndCompany
          />
        </div>
      </div>
    </TwWrapper>
  )
})
